export class ServiceHistoryDashboardQueryParameters {
  cachedXmlDateFrom?: Date;
  cachedXmlDateTo?: Date;
  convertXmlToJson?: boolean; // Not on table but needed for query
  embed?: Array<string>;
  id?: string;
  page?: number;
  pageSize?: number;
  odometer?: number;
  serviceHistoryDashboardCacheTimeId?: string;
  vehicleId?: string;
  employeeId?: string;
  symptomCodes?: string;
  transType?: string;

  constructor(obj?: ServiceHistoryDashboardQueryParameters) {
    if (obj) Object.assign(this, obj);
  }
}
